module.exports = __webpack_public_path__ + "img/api-white.ee970858.svg";